import React from 'react';

import { Grid, Typography, useMediaQuery } from '@mui/material';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import { useTheme } from '@mui/material/styles';


const Dashboard = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div style={{ background: theme.palette.background.default, height: '100vh' }}>
      <Navbar />
      <Grid container style={{ height: '100%' }}>
        {!isSmallScreen && (
          <Grid item xs={2} style={{ height: '100%' }}>
            <Sidebar />
          </Grid>
        )}
        <Grid item xs={12} sm={10} style={{ height: '100%' }}>
        
          <Typography variant="h3">Hi there</Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
